import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { NewVersionPrompt } from "./components/chrome/NewVersionPrompt";
import { AuthProvider } from "./auth/AuthContext";
import { HelpProvider } from "./help/HelpController";
import { ThemeProvider } from "./theme/ThemeProvider";
import { ThemeAccountSync } from "./theme/ThemeAccountSync";
import { WorkspaceModeProvider } from "./workspace/WorkspaceModeProvider";
import { AuthoringProvider } from "./authoring/AuthoringProvider";
import { initTelemetry } from "./telemetry";
import "./i18n";
import "./index.css";

initTelemetry();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        {/* Outside AuthProvider: a newer deploy matters on the sign-in page and the sessionless pages too. */}
        <NewVersionPrompt />
        <AuthProvider>
          {/* Inside AuthProvider: the theme follows the signed-in person, not the browser (KEY-755). */}
          <ThemeAccountSync />
          {/* Inside AuthProvider: it reads the signed-in person's stored choice from the server. */}
          <WorkspaceModeProvider>
            {/* Inside AuthProvider too: whether this person can build a dial is asked of the server once they're signed in (KEY-560). */}
            <AuthoringProvider>
              <HelpProvider>
                <App />
              </HelpProvider>
            </AuthoringProvider>
          </WorkspaceModeProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
